import {
    Anchor,
    Button,
    Container,
    Divider,
    Flex,
    Paper,
    PasswordInput,
    Space,
    Stack,
    Text,
    TextInput,
} from '@mantine/core';
import { Link, Navigate, useLocation, useNavigate } from 'react-router-dom';
import { isNotEmpty, useForm } from '@mantine/form';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import HCaptcha from '@hcaptcha/react-hcaptcha';
import { faSpinnerThird } from '@fortawesome/pro-solid-svg-icons';
import { useAuthStore } from '../../../store';
import useLogin from '../../../http/mutations/auth/useLogin';

const Login = ({ ...props }) => {
    const navigate = useNavigate();
    const location = useLocation();

    const { isPending, mutate: login } = useLogin();

    const form = useForm({
        initialValues: {
            emailOrUsername: '',
            password: '',
        },

        validate: {
            emailOrUsername: isNotEmpty('Username or email is required'),
            password: (val) =>
                val.length <= 6
                    ? 'Password should include at least 6 characters'
                    : null,
        },
    });

    const handleCaptcha = (token, ekey) => {
        form.setFieldValue('captchaResponse', token);
        form.setFieldValue('captchaSessionId', ekey);
    };

    const { from } = location.state || { from: { pathname: '/campaigns' } };
    const onSubmit = (model) => {
        login(model, {
            onSuccess(data, variables, context) {
                navigate(from, {
                    replace: true,
                });
            },
            onError(error, variables, context) {
                // setError(error);
            },
        });
    };

    return (
        <Container
            size={'sm'}
            my={30}>
            <Flex
                align={'center'}
                justify={'center'}>
                <Paper
                    radius='md'
                    p='xl'
                    withBorder>
                    <Text
                        size='lg'
                        fw={500}>
                        Welcome to <strong>Reach</strong>SMS, login with
                    </Text>

                    <Divider
                        label='Or continue with email'
                        labelPosition='center'
                        my='lg'
                    />

                    <form onSubmit={form.onSubmit(onSubmit)}>
                        <Stack>
                            <TextInput
                                required
                                label='Email'
                                placeholder='hello@reachsms.vip'
                                radius='md'
                                {...form.getInputProps('emailOrUsername')}
                            />

                            <PasswordInput
                                required
                                label='Password'
                                placeholder='Your password'
                                radius='md'
                                {...form.getInputProps('password')}
                            />

                            {/*<>
                                <HCaptcha
                                    id={'login-captcha'}
                                    sitekey={
                                        import.meta.env.VITE_APP_HCAPTCHA_KEY
                                    }
                                    onVerify={handleCaptcha}
                                />
                            </>*/}
                        </Stack>

                        <Stack
                            justify='space-between'
                            align={'center'}
                            mt='md'>
                            <Button
                                type='submit'
                                radius='xl'
                                px='xl'
                                fullWidth
                                disabled={isPending || !form.isValid()}
                                rightSection={
                                    isPending ? (
                                        <FontAwesomeIcon
                                            icon={faSpinnerThird}
                                            spin
                                        />
                                    ) : null
                                }>
                                Login
                            </Button>
                            <Text
                                size='xs'
                                c='dimmed'>
                                Don't have an account?{' '}
                                <Anchor
                                    to={'/auth/signup'}
                                    component={Link}>
                                    Create one
                                </Anchor>
                            </Text>
                            <Anchor
                                to={'/auth/forgot'}
                                component={Link}
                                size='xs'>
                                Forgot your password?
                            </Anchor>
                        </Stack>
                    </form>
                </Paper>
            </Flex>
        </Container>
    );
};
export default Login;
